class ProductDuoForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.btn = this.querySelector('.jp-product-duo__atc-btn');
    this.originalText = this.btn?.textContent ?? 'Add to Cart';
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
  }

  async onSubmit(e) {
    e.preventDefault();
    if (!this.btn || this.btn.disabled) return;

    this.btn.disabled = true;
    this.btn.textContent = 'Adding…';

    try {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!response.ok) throw new Error('cart-add-failed');
      const cartData = await response.json();

      this.btn.textContent = 'Added ✓';

      // Same pub/sub event product-form.js and jp-cart-drawer.js use — this
      // is what makes jp-cart-drawer refresh its contents AND slide open.
      // (Previously this dispatched a plain 'cart:refresh' DOM event that
      // nothing was actually listening for, so the drawer never opened.)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-duo-form', cartData });
      }

      setTimeout(() => {
        this.btn.textContent = this.originalText;
        this.btn.disabled = false;
      }, 1800);
    } catch {
      this.btn.textContent = this.originalText;
      this.btn.disabled = false;
    }
  }
}

customElements.define('product-duo-form', ProductDuoForm);
